export default __webpack_public_path__ + "static/media/highlighting_link_site.0433ea86.svg";